<template>
  <div class="home">
    <el-container style="min-height: 100vh">
      <el-header style="background: #285bed;">
        <m-top></m-top>
      </el-header>
      <el-container>
        <el-aside width="200px" style="background: #ffffff">
          <m-menu></m-menu>
        </el-aside>
        <el-container>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import MTop from "@/components/MTop.vue";
import MMenu from "@/components/MMenu.vue";

export default {
  name: "app",
  components: {
    MTop,
    MMenu
  }
};
</script>

<style lang="scss">
.home {
  width: 100%;
  height: 100%;
  background: #ecf0f3;
}
.el-dialog__header {
  text-align: center;
  background: #ffffff;
}
.footer-title {
  text-align: center;
  font-size: 14px;
  color: #777777;
}
.ellipsis-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
